document.addEventListener("DOMContentLoaded", () => {

  const input = document.getElementById("kg-search");
  const noProducts = document.getElementById("kg-no-products");
  const clearBtn = document.getElementById("kg-clear-search");
  const pagination = document.querySelector(".pagination-wrapper");

  if (!input || !noProducts || !clearBtn) return;

  function filterProducts() {

    const value = input.value.trim().toLowerCase();
    let visibleCount = 0;

    document.querySelectorAll("#product-grid > li").forEach((item) => {

      const title = item.querySelector(".card__heading");

      if (!title) return;

      const productTitle = title.textContent.toLowerCase();

      if (productTitle.includes(value)) {
        item.style.display = "";
        visibleCount++;
      } else {
        item.style.display = "none";
      }

    });

    if (visibleCount === 0) {
      noProducts.style.display = "block";

      if (pagination) {
        pagination.style.display = "none";
      }

    } else {
      noProducts.style.display = "none";

      if (pagination) {
        pagination.style.display = "";
      }
    }
  }

  input.addEventListener("keyup", filterProducts);

  clearBtn.addEventListener("click", () => {

    input.value = "";

    document.querySelectorAll("#product-grid > li").forEach((item) => {
      item.style.display = "";
    });

    noProducts.style.display = "none";

    if (pagination) {
      pagination.style.display = "";
    }

    input.focus();

  });

});
